import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.8 4a.8.8 0 00-.8.8v.9a1.9 1.9 0 01-1.9 1.9H8.4c-.438 0-.8.362-.8.8v2.7A1.9 1.9 0 015.7 13h-.9a.8.8 0 000 1.6h.9c1.05 0 1.9.85 1.9 1.9v2.7a.8.8 0 00.8.8H11v-.8a2.8 2.8 0 012.8-2.8h.018l.171.006.019.002A2.8 2.8 0 0116.6 19.2v.8h2.582l.094-.003A.8.8 0 0020 19.2v-2.6h-.821l-.2-.009-.02-.001a2.773 2.773 0 01-1.426-.54 2.819 2.819 0 01-.56-.553 2.805 2.805 0 01-.564-1.908h-.002c.002-.023.005-.062.011-.109A2.8 2.8 0 0119.2 11h.8V8.4a.8.8 0 00-.8-.8h-2.7a1.9 1.9 0 01-1.9-1.9v-.9a.8.8 0 00-.8-.8zm4.68 10.15a.8.8 0 00.144.205l.031.03a.82.82 0 00.081.067l.003.002.038.026c.002 0 .002 0 .003.002l.013.007.066.035a.792.792 0 00.116.044l.019.005.055.013h.006l.066.01.1.004h.879c1.05 0 1.9.85 1.9 1.9v2.7a2.8 2.8 0 01-2.592 2.792l-.018.002-.172.006H16.5a1.9 1.9 0 01-1.9-1.9v-.9a.8.8 0 00-.724-.796l-.09-.004a.8.8 0 00-.786.8v.9a1.9 1.9 0 01-1.68 1.887l-.029.004-.162.009H8.4a2.8 2.8 0 01-2.8-2.8v-2.6h-.8a2.8 2.8 0 110-5.6h.8V8.4c0-1.542 1.258-2.8 2.8-2.8H11v-.8a2.8 2.8 0 115.6 0v.8h2.6A2.8 2.8 0 0122 8.4v2.7a1.9 1.9 0 01-1.9 1.9h-.9a.8.8 0 00-.777.992l.012.043.005.016.003.009.011.031.006.014.009.02.01.024z",
      fill: "#2d6ded"
    }
  )
), v = e;
export {
  v as default
};
